export default prizepool =>
  prizepool && prizepool.total && !['tba', 'tbd', 'n/a'].includes(prizepool.total.toLowerCase());
